import { render } from "./EmdLogo.vue?vue&type=template&id=d20648f4"
import script from "./EmdLogo.vue?vue&type=script&lang=js"
export * from "./EmdLogo.vue?vue&type=script&lang=js"

import "./EmdLogo.vue?vue&type=style&index=0&id=d20648f4&lang=css"

import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__